import * as React from 'react';
import CloudinaryImage from 'components/CloudinaryImage';

import { __t, applyTranslations } from 'utils/language';

import './realm-outfit-image.scss';

applyTranslations(require('./realm-outfit-image.i18n.json'));

const PREVIEW_WIDTH = 183;
const PREVIEW_HEIGHT = 265;

type Props = {
  imageIndex?: number,
  url: string,
  name?: string,
  disabled?: boolean,
  contextMenu?: React.ReactNode
}

const RealmOutfitImage = (props: Props): JSX.Element => {
  const { contextMenu, disabled, url, name, imageIndex } = props;

  const handleCancelGallery = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <div className="realm-outfit-image">
      {
        imageIndex && (
          <div
            className="realm-outfit-image__title"
            onClick={handleCancelGallery}
          >
            {`${imageIndex} ${imageIndex === 1 ? '- Primary picture' : ''}`}
            {contextMenu}
          </div>
        )
      }
      <div className="realm-outfit-image__preview">
        <a
          className="realm-outfit-image__media-preview"
          rel="noopener noreferrer"
          target="_blank"
          href={disabled ? undefined : url}
        >
          <div className="realm-outfit-image__thumbnail">
            <CloudinaryImage
              image={{ url }}
              width={PREVIEW_WIDTH}
              height={PREVIEW_HEIGHT}
            />
          </div>
        </a>
      </div>
      <div
        className="realm-outfit-image__footer"
        onClick={handleCancelGallery}
      >
        {
          !disabled && (
            <a
              rel="noopener noreferrer"
              target="_blank"
              href={url}
            >
              <span className="realm-outfit-image__filename text-overflow-ellipsis">
                {name || __t('realm_outfit_image.new_tab')}
              </span>
            </a>
          )
        }
      </div>
    </div>
  );
};

export default RealmOutfitImage;
